import {
  generateCodeChallengeFromVerifier,
  generateCodeVerifier,
} from './utils'
import { type IFinancialAccountRepository } from '../../interfaces/IFinancialAccountRepository'
import { BankingUseCaseErrors } from '../BankingUseCaseErrors'

export class GetScaAuthCodeUseCase {
  constructor(
    private deps: {
      financialAccountRepository: IFinancialAccountRepository
    }
  ) {}

  execute = async () => {
    let codeVerifier: string
    let codeChallenge: string

    try {
      codeVerifier = generateCodeVerifier()
      codeChallenge = await generateCodeChallengeFromVerifier(codeVerifier)
    } catch (e) {
      throw new BankingUseCaseErrors({
        name: 'ERROR_GENERATING_CODE_CHALLENGE_OR_VERIFIER',
        message: 'Failed to generate code challenge or verifier',
      })
    }

    try {
      const res =
        await this.deps.financialAccountRepository.getScaAuthCode(codeChallenge)

      return {
        authCode: res.data.authCode,
        codeVerifier,
      }
    } catch (err) {
      throw new BankingUseCaseErrors({
        name: 'ERROR_GETTING_SCA_AUTH_CODE',
        message: 'Failed to fetch SCA auth code',
      })
    }
  }
}
